module.exports = __webpack_public_path__ + "app-static/img/a2.5c88f904.png";